module.exports = __webpack_public_path__ + "static/media/8_IMAGE_3-PHOTOBIOREACTOR-desktop.e7ec53fb.jpg";